import { Component } from 'react';
import { Logger } from '../js/helpers/Logger.js';

const getError = e => {
	if (e.error && e.error.message && e.error.stack) {
		return e.error.message + ' ' + e.error.stack;
	} else if (e.message) {
		return e.message;
	} else if (typeof e === 'object') {
		return JSON.stringify(e);
	}
	return e;
};

class ErrorHandler extends Component {
	constructor(props) {
		super(props);
		this.offlineTime = null;
	}

	componentDidMount() {
		this.overwriteConsole();
		window.addEventListener('error', this.onErrorClient);
		window.addEventListener('offline', this.offline);
		window.addEventListener('online', this.online);
	}

	offline(e) {
		this.offlineTime = new Date(e.timeStamp);
		Logger.JsWarning('Network status: Offline');
	}
	online(e) {
		let online = new Date(e.timeStamp);
		if (this.offlineTime) {
			Logger.Info('Network status: Reconnected , offline time in sec:  ', (online - this.offlineTime) / 1000);
		} else {
			Logger.Info('Network status: Online');
		}
	}

	onErrorClient(e) {
		Logger.JsError('JS ErrorClient', getError(e));
	}

	overwriteConsole() {
		let console = (oldCons => {
			return {
				...oldCons,
				warn: text => {
					oldCons.warn(text);
					Logger.JsWarning('JS Warning', getError(text));
				},
				error: text => {
					oldCons.error(text);
					Logger.JsError('JS Error', getError(text));
				}
			};
		})(window.console);
		window.console = console;
	}

	componentDidCatch(error) {
		Logger.JsError('JS ErrorDidCatch', getError(error));
	}

	render() {
		return this.props.children;
	}
}

export default ErrorHandler;



// WEBPACK FOOTER //
// ./src/components/ErrorHandler.jsx